import { Button } from '@qodo/design-system';
import { Download } from 'lucide-react';
import { Step } from 'shared/InstallationDialog';
import { downloadFile } from 'utils/downloadFile';
import { spawn } from 'utils/translations';
import { ExternalLink } from '../../ExternalLink';
import { Image } from '../../Image';
import { QODO_LOGO_FILENAME, QODO_LOGO_URL } from '../consts';
import { useGithubInstallation } from '../githubInstallationContext';
import { getAppSettingsUrlFromOrganizationUrlAndSlug } from '../utils';
import uploadLogoScreenshot from '/images/github-installation/install-app-upload-logo.svg';

export const RecommendedDisplay = () => {
  const { organizationUrl, slug } = useGithubInstallation();

  const spawnRecommendedDisplay = spawn(
    'dialogs.github-installation.recommended-display',
  );

  const appSettingsUrl = getAppSettingsUrlFromOrganizationUrlAndSlug(
    organizationUrl,
    slug,
  );

  const onDownloadLogo = () => {
    downloadFile(QODO_LOGO_URL, QODO_LOGO_FILENAME);
  };

  return (
    <Step
      title={spawnRecommendedDisplay('title')}
      description={spawnRecommendedDisplay('description')}
    >
      <Button
        size="xs"
        variant="outline"
        className="group gap-1.5 self-start"
        onClick={onDownloadLogo}
      >
        {spawnRecommendedDisplay('download-logo-button')}
        <Download className="stroke-text-action-neutral-idle" size="16px" />
      </Button>
      <div className="flex flex-col gap-[21px]">
        <ExternalLink url={appSettingsUrl} className="self-start text-xs">
          {spawnRecommendedDisplay('upload-link')}
        </ExternalLink>
        <Image
          source={uploadLogoScreenshot}
          alt={spawnRecommendedDisplay('upload-logo-alt-text')}
        />
      </div>
    </Step>
  );
};
